//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function(module) {
  'use strict';
  module
    .controller('agentAssignmentController', ['$scope', 'agentAssignment', 'progressBar', 'ngDialog',
      'uiGridConstants', 'commonDialog', 'commonDialogMessage', 'organizations', 'members', '$q',
      'orgFilterService', 'toastr', 'authService','clientSelectService', 'agencySelectService', 'toastFactory','$window',
      function($scope, agentAssignment, progressBar, ngDialog, uiGridConstants, commonDialog,
        commonDialogMessage, organizations, members, $q, orgFilterService, toastr, authService, clientSelectService,
        agencySelectService, toastFactory,$window
      ) {
        //variable declaration
        const progress = progressBar.getProgressBar();
        let _addTravelAgentList = [];
        let _deleteTravelAgentList = [];
        let _unassignedSnapshot = [];
        let _assignedSnapshot = [];
        $scope.ownOrgName = authService.getLoginMember().Organization.Name;
        const storage = $window.localStorage;

        function dialogBox(dialogMessage) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = `<p>${dialogMessage}</p>`;
              $scope.errTitle = 'Agent Assignment Error';
            },],
            plain: true,
          });
        }
        // Validate that filtered organization id is defined
        function validateOrganization() {
          const organization = clientSelectService.getSelectedClient();
          return organization.id != null && Number.isInteger(organization.id);
        };
        // Watch orgFilterService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function() {
          return clientSelectService.getSelectedClient();
        }, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            clearGrids();
            setGridData();
          }
        }, true);

        function clearGrids() {
          $scope.gridUnassignedTravelAgents.data = [];
          $scope.gridUnassignedTravelAgents.totalItems = 0;
          $scope.gridAssignedTravelAgents.data = [];
          $scope.gridAssignedTravelAgents.totalItems = 0;
          $scope.unassignedGridApi.grid.selection.selectAll = false;
          $scope.assignedGridApi.grid.selection.selectAll = false;
        };

        function getTravelAgencyId(filterOrgId) {
          return organizations.getOrganizationById(filterOrgId).then(function(organization) {
            return organization.data.TravelAgencyId;
          });
        };
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }
        // Sets both grids' data
        function setGridData() {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            if (validateOrganization()) {
              progress.start();
              // Organization to assign/unassign travel agents to/from
              let selectedAgency
              if (storage.getItem('selectedClient')) {
                selectedAgency = JSON.parse(storage.getItem('selectedAgency'))
              }
              const filterOrg = clientSelectService.getSelectedClient();
              const filterOrgId = filterOrg.id;
              $scope.filterOrgName = filterOrg.name;
              // All agent from loginMember's travel agency
              const promiseAll = members.getAllAgentsByAdmin(selectedAgency.id);
              // Travel Agent Organizations for filtered organization
              const promiseAssigned = agentAssignment.getTravelAgentOrganizationsById(filterOrgId);
              const promiseTravelAgencyId = getTravelAgencyId(filterOrgId);
              $q.all([promiseAll, promiseAssigned, promiseTravelAgencyId]).then(function(responses) {
                if (responses[0].data.length > 0) {
                  const travelAgencyId = responses[2];
                  // Processing
                  const assignedContext = processAssignedAgents(responses[1].data);
                  const unassignedContext = processUnassignedAgents(responses[0].data, assignedContext,
                    travelAgencyId);
                  // Populate grids
                  clearGrids();
                  $scope.gridUnassignedTravelAgents.data = unassignedContext;
                  $scope.gridUnassignedTravelAgents.totalItems = unassignedContext.length;
                  $scope.gridAssignedTravelAgents.data = assignedContext;
                  $scope.gridAssignedTravelAgents.totalItems = assignedContext.length;
                  // Save snapshots of initial grid data
                  _unassignedSnapshot = $scope.gridUnassignedTravelAgents.data.slice(0);
                  _assignedSnapshot = $scope.gridAssignedTravelAgents.data.slice(0);
                } else {
                  toastr.warning('No content received.', 'Alert');
                }
              }, function(err) {
                dialogBox(err.statusText);
              }).finally(function() {
                progress.complete();
              });
            } else {
              $scope.filterOrgName = null;
            }
          } else if (valid.agencyValid) {
            //toastFactory.toast_info('Please select a client.');
          } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
        };
        // Filter out assigned agents from all agents
        function processUnassignedAgents(membersInfo, assignedInfo, travelAgencyId) {
            if (!!membersInfo && !!assignedInfo) {
            // Grab MemberId's of assigned agents
            let assignedIds = _.map(assignedInfo, 'MemberId');
            return membersInfo.filter(function(member) {
              // Select members whose MemberId's are not in the assignedIds array
              return assignedIds.indexOf(member.Id) < 0 && member.OrganizationId === travelAgencyId;
            }).map(function(member) {
              return {
                MemberId: member.Id,
                MemberName: member.DisplayName,
                OrganizationId: member.OrganizationId,
              };
            });
          }
        };
        // Only returns a projection
        function processAssignedAgents(assignedInfo) {
          if (!!assignedInfo) {
            return assignedInfo.map(function(travelAgent) {
              return {
                MemberId: travelAgent.Member.Id,
                MemberName: travelAgent.Member.DisplayName,
                OrganizationId: travelAgent.OrganizationId,
                TravelAgentOrganizationId: travelAgent.Id,
              };
            });
          }
        };
        // addTravelAgent and deleteTravelAgent should only act as purely visual functions --
        // the values sent to server will depend on diff from snapshotted data at time of action.
        $scope.addTravelAgent = function() {
         
          const unassignedTravelAgents = $scope.gridUnassignedTravelAgents.data.filter(function(travelAgent) {          
            return _addTravelAgentList.indexOf(travelAgent) === -1
          });        
       
          $scope.gridUnassignedTravelAgents.data = unassignedTravelAgents;
          $scope.gridUnassignedTravelAgents.totalItems =  unassignedTravelAgents.length;

          const assignedAgents = $scope.gridAssignedTravelAgents.data.concat(_addTravelAgentList);
          $scope.gridAssignedTravelAgents.data = assignedAgents;
          $scope.gridAssignedTravelAgents.totalItems = assignedAgents.length;
       
          // Clear _addTravelAgentList
          _addTravelAgentList.length = 0;
          // Deselect left-side selectAll checkbox
          $scope.unassignedGridApi.grid.selection.selectAll = false;
        };
        $scope.deleteTravelAgent = function() {
          _deleteTravelAgentList.forEach(function(delAgent) {
            // Remove row from right
            $scope.gridAssignedTravelAgents.data.splice($scope.gridAssignedTravelAgents.data.indexOf(delAgent),
              1);
            $scope.gridAssignedTravelAgents.totalItems--;
            // Push row to left
            $scope.gridUnassignedTravelAgents.data.push(delAgent);
            $scope.gridUnassignedTravelAgents.totalItems++;
          });
          // Clear _deleteTravelAgentList
          _deleteTravelAgentList.length = 0;
          // Deselect right-side selectAll checkbox
          $scope.assignedGridApi.grid.selection.selectAll = false;
        };
        // Send changes to API
        $scope.saveTravelAgents = function() {
          if (validateOrganization()) {
            const orgId = clientSelectService.getSelectedClient().id;
            // Check diffs against snapshots
            const toAdd = _.differenceWith($scope.gridAssignedTravelAgents.data, _assignedSnapshot, _.isEqual)
              .map(function(travelAgent) {
                return {
                  Id: 0,
                  MemberId: travelAgent.MemberId,
                  OrganizationId: orgId,
                };
              });
            const toDelete = _.differenceWith($scope.gridUnassignedTravelAgents.data, _unassignedSnapshot, _.isEqual)
              .map(function(travelAgent) {
                return {
                  TravelAgentOrganizationId: travelAgent.TravelAgentOrganizationId,
                };
              });
            const promiseAdd = agentAssignment.addTravelAgentOrganizations(toAdd)
              .then(function(response) {
                return !!response;
              });
            const promiseDel = agentAssignment.deleteTravelAgentOrganizations(toDelete)
              .then(function(response) {
                return !!response;
              });
            let promises = [];
            if (toAdd.length > 0) {
              promises.push(promiseAdd);
            }
            if (toDelete.length > 0) {
              promises.push(promiseDel);
            }
            if (promises.length > 0) {
              progress.start();
              $q.all(promises).then(function(responses) {
                progress.complete();
                if ((responses.length === 2 && responses[0] && responses[1]) || (responses.length === 1 &&
                    responses[0])) {
                  toastr.success('Changes were successfully made.', 'Success');
                  setGridData();
                } else {
                  toastr.error('An error occurred while making changes.', 'Error');
                }
              });
            } else {
              toastr.info('No changes were made.', 'Info');
            }
          }
        };
        // Resync grid data with server
        $scope.reset = function() {
          clearGrids();
          setGridData();
          _addTravelAgentList.length = 0;
          _deleteTravelAgentList.length = 0;
          if (validateOrganization()) {
            toastr.info('Grids were reset.', 'Reset');
          }
        };
        // ui-grid below        
        const columnDefs = [{
          name: 'MemberName',
          displayName: 'Travel Agent',
          visible: true,
          enableHiding: false,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          sort: {
            direction: uiGridConstants.ASC,
            priority: 0,
          },
        }, ];
        const gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: false,
          paginationPageSize: 25,
          useExternalPagination: false,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: true,
          enableRowHeaderSelection: true,
          multiSelect: true,
          enableSelectionBatchEvent: true,
          columnDefs: columnDefs,
        };
        /* TODO: enableFullRowSelection not working as intended -
        see https://github.com/angular-ui/ui-grid/issues/2254, https://github.com/angular-ui/ui-grid/commit/679b615bd19ff71ff1e835d7f6066e7a919f279a
        */
        // Left grid (Unassigned Agents)
        $scope.gridUnassignedTravelAgents = _.cloneDeep(gridOptions);
        $scope.gridUnassignedTravelAgents.onRegisterApi = function(gridApi) {
          $scope.unassignedGridApi = gridApi;
          gridApi.selection.on.rowSelectionChanged($scope, function(row) {
            if (row.isSelected) {
              _addTravelAgentList.push(row.entity);
            } else {
              _addTravelAgentList.splice(_addTravelAgentList.indexOf(row.entity), 1);
            }
          });
          // Handle mass selection events
          gridApi.selection.on.rowSelectionChangedBatch($scope, function(rows) {
            _addTravelAgentList = gridApi.selection.getSelectedRows();
          });
        };
        // Right grid (Assigned Agents)
        $scope.gridAssignedTravelAgents = _.cloneDeep(gridOptions);
        $scope.gridAssignedTravelAgents.onRegisterApi = function(gridApi) {
          $scope.assignedGridApi = gridApi;
          gridApi.selection.on.rowSelectionChanged($scope, function(row) {
            if (row.isSelected) {
              _deleteTravelAgentList.push(row.entity);
            } else {
              _deleteTravelAgentList.splice(_deleteTravelAgentList.indexOf(row.entity), 1);
            }
          });
          // Handle mass selection events
          gridApi.selection.on.rowSelectionChangedBatch($scope, function(rows) {
            _deleteTravelAgentList = gridApi.selection.getSelectedRows();
          });
        };
        // End ui-grid
        setGridData();
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/agentAssignmentController.js